import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=f1eaff76&scoped=true"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"
import style0 from "./productCard.vue?vue&type=style&index=0&id=f1eaff76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1eaff76",
  null
  
)

export default component.exports